import { Pipe, PipeTransform } from '@angular/core'
import { DateFormatType, formatDate } from '../functions'

@Pipe({
  name: 'epochUTC',
  standalone: false,
})
export class EpochUTCPipe implements PipeTransform {
  transform(value: any, format: DateFormatType = 'daydate', defaultValue = $localize`Never`): string {
    return formatDate(value, format, true, defaultValue)
  }
}
